import { datadogLogs, LogsMessage, StatusType } from '@datadog/browser-logs'

type LoggerProps = Pick<LogsMessage, 'message' | 'context'> & {
  level: StatusType
}

type UseLoggerReturnValue = {
  logger: (props: LoggerProps) => void
}

export const useLogger = (): UseLoggerReturnValue => {
  const logger = ({ level, message, context }: LoggerProps): void => {
    datadogLogs.logger[level](message, context)
  }

  return {
    logger,
  }
}
